import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarehouse } from '@fortawesome/free-solid-svg-icons';
import { blockInvalidChar } from 'src/marketConnect/helpers';

interface InventoryRowData {
  id: number;
  location?: string;
  location_name?: string;
  quantity: number | string;
  available_quantity?: number;
  reserve_quantity?: number;
  on_hand?: number;
}

interface InventoryDetailsTableProps {
  inventoryRows: InventoryRowData[];
  handleQuantityChange: (id: number, value: number | "") => void;
  maxHeight?: string;
}

const InventoryDetailsTable: React.FC<InventoryDetailsTableProps> = ({
  inventoryRows,
  handleQuantityChange,
  maxHeight = '395px',
}) => {
  return (
    <div className="border rounded" style={{ maxHeight, overflowY: 'auto' }}>
      <table className="table table-row-dashed table-row-gray-300 align-middle gs-3 gy-3 mb-0">
        <thead className="bg-light sticky-top" style={{ zIndex: 1 }}>
          <tr className="fw-bold text-gray-800 border-bottom">
            <th className="min-w-150px ps-4">
              <div className="d-flex align-items-center gap-2">
                <span>Warehouse</span>
                <button
                  type="button"
                  className="btn btn-icon btn-sm btn-light bg-white border"
                  onClick={() => window.open('/warehouse-listing', '_blank')}
                  style={{ width: '28px', height: '28px', borderRadius: '8px' }}
                  title="Go to warehouse listing"
                >
                  <FontAwesomeIcon icon={faWarehouse} />
                </button>
              </div>
            </th>
            <th className="text-center w-125px">Available</th>
            <th className="text-center w-100px">Reserved</th>
            <th className="text-center w-100px pe-4">On Hand</th>
          </tr>
        </thead>
        <tbody>
          {inventoryRows.length > 0 ? (
            inventoryRows.map((row) => (
              <tr key={row.id}>
                <td className="ps-4 fw-semibold text-gray-700">
                  {row.location_name || row.location || '-'}
                </td>
                <td className="text-center">
                  <input
                    type="number"
                    className="form-control text-center mx-auto"
                    min={0}
                    value={row.quantity ?? row.available_quantity ?? ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      handleQuantityChange(row.id, value === "" ? "" : Number(value));
                    }}
                    style={{ maxWidth: '100px' }}
                    onKeyDown={blockInvalidChar}
                  />
                </td>
                <td className="text-center text-gray-600 fw-semibold">
                  {row.reserve_quantity ?? 0}
                </td>
                <td className="text-center text-gray-600 fw-semibold pe-4">
                  {row.on_hand ?? 0}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4} className="text-center text-muted py-4">
                No locations found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default InventoryDetailsTable;
